<div class="container">
    <header>
        <h1>Request PDA</h1>
        <button mat-icon-button (click)="sidenav.controller.close()">
            <mat-icon>close</mat-icon>
        </button>
    </header>
    <main>
        <h1>Request your PDA or contact us for more information:</h1>
        <a
            mat-raised-button
            color="accent"
            href="mailto:commercial.agency@wilsonsons.com.br"
        >
            commercial.agency@wilsonsons.com.br
        </a>
    </main>
</div>